import { StyledCta } from 'components/marketingSite/shared/Cta.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  radius,
  screen,
  spacing
} from '../../../theme';

export const StyledBlog = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  padding: ${spacing('xl4')} ${spacing('md')};
  margin: 0;
  text-align: center;
  background-color: ${color('midnight_100')};

  > * {
    max-width: ${container('xl')};
    margin: auto;
    width: 100%;
  }
  > ${StyledCta} {
    max-width: ${container('md')};
  }
`;

export const StyledBlogHeader = styled.header`
  text-align: center;
  font-size: ${fontSize('lg')};
`;

export const StyledTags = styled.div`
  border-top: 1px solid ${color('midnight_200')};
  border-bottom: 1px solid ${color('midnight_200')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('xs')}; /* 
  margin-bottom: ${spacing('xl3')}; */
`;

export const StyledBlogCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('lg')};
  width: 100%; // use full width of StyledBlog

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: ${screen('lg')}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledBlogSpotlightCards = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${radius('lg')};
  background-color: ${color('white')};
  margin-bottom: ${spacing('xl')};
  padding: ${spacing('lg')};
  color: ${color('emerald_750')};
  gap: ${spacing('lg')};
  box-shadow: 8px 8px 32px rgba(44, 62, 80, 0.1);
  &:hover {
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 12px,
      rgba(38, 26, 25, 0.04) 0px 1.51px 5.3px 12px,
      rgba(38, 26, 25, 0.05) 0px 3.03px 4.54px 12px;
    transition: box-shadow 0.3s ease-in-out;
  }
`;
